import "./InputWrapper.scss"
import React from 'react'
import classNames from "classnames";

const InputWrapper = ({inputWrapperClassName, children, name, label, formik, error, description, required = false, layout = "horizontal"}) => {
    const fieldError = error || (formik?.touched[name] && formik?.errors[name]);

    return (
        <div className={classNames("input-wrapper", layout, inputWrapperClassName)}>
            {label && (
                <label
                    htmlFor={name}
                    className={classNames({"required": required})}
                >
                    {label}
                </label>
            )}
            {children}
            {fieldError && <span className="error">{fieldError}</span>}
            {description && <p className="description">{description}</p>}
        </div>
    )
}

export default InputWrapper
